<div class="box-loja">
  <div class="dados-loja">
    <div class="mome">{{loja.fantasia}}</div>
    <div class="endereco-loja">
      <div class="endereco-loja-texto">
        {{loja.logradouro}}, {{loja.numero}} - {{loja.bairro}} - {{loja.cidade}}
      </div>
      <div (click)="mapa(loja)" class="endereco-loja-icone">
        <i class="fad fa-map-marked-alt" style="--fa-primary-color: #e75546; --fa-secondary-color: #34a853;"></i>
      </div>
    </div>

  </div>

  <div *ngIf="vendedores.length > 0" class="vendedores">
    <h1>Nossos Vendedores</h1>
    <ul>
      <li *ngFor="let vendedor of vendedores">
        <div class="vendedor">
          <div class="foto"><img [src]="vendedor.fotoBase64" alt="foto" onerror="this.src='img/userNone.png';"></div>
          <div class="nome">
            <span>{{vendedor.nome | titlecase}}</span>
            <br>
            <small>{{formatarTelefone(vendedor)}}</small>
          </div>
          <div class="contato"><i *ngIf="(vendedor.whatsApp + '').length >= 10" (click)="abrirWhatsApp(vendedor)" class="fab fa-whatsapp"></i></div>
        </div>
      </li>
    </ul>
  </div>

  <div *ngIf="vendedores.length == 0" class="nenhum-vendedor">
    Nenhum vendedor disponível nesta loja.
  </div>
</div>
